import TaskRoutes, { TASKS_BASE_ROUTES } from './TaskRoutes';

export { TaskRoutes, TASKS_BASE_ROUTES };
